/* eslint-disable import/no-named-as-default */
/* eslint-disable no-shadow */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import teamMembersType from "./types/teamMembersType";
import TeamMember from "./TeamMember";
import { loadTeamMembers } from "../../actions/agencyProfileActions";
import {
  Wrapper,
  PaginationButtons,
  PrevButtonWrapper,
  PrevButton,
  NextButtonWrapper,
  NextButton,
} from "./styles/team-styles";

export class Team extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fromIndex: 0,
      toIndex: 3,
      currentPage: 1,
      perPageCount: 3,
    };
  }

  componentDidMount() {
    const { loadTeamMembers, recruiterUserId, companyId } = this.props;

    loadTeamMembers(recruiterUserId, companyId);
  }

  handleTextLength = (text) => {
    if (text.length > 200) {
      return `"${text.slice(0, 200)}..."${" "}`;
    }
    return `"${text}..."`;
  };

  handlePrevButton = () => {
    const { fromIndex, toIndex, currentPage, perPageCount } = this.state;
    const { loadTeamMembers, recruiterUserId } = this.props;

    loadTeamMembers(recruiterUserId);
    if (currentPage > 1) {
      this.setState({
        fromIndex: fromIndex - perPageCount,
        toIndex: toIndex - perPageCount,
        currentPage: currentPage - 1,
      });
    }
  };

  handleNextButton = () => {
    const { fromIndex, toIndex, currentPage, perPageCount } = this.state;
    const { loadTeamMembers, recruiterUserId, companyId } = this.props;

    loadTeamMembers(recruiterUserId, companyId);
    this.setState({
      fromIndex: fromIndex + perPageCount,
      toIndex: toIndex + perPageCount,
      currentPage: currentPage + 1,
    });
  };

  render() {
    const { teamMembers, companyName } = this.props;
    const { fromIndex, toIndex, currentPage, perPageCount } = this.state;
    const displayedMembersCount = currentPage * perPageCount;

    if (teamMembers.length > 0) {
      return (
        <Wrapper>
          {teamMembers.slice(fromIndex, toIndex).map((member) => (
            <TeamMember key={member.id} {...member} companyName={companyName} />
          ))}
          {teamMembers.length > 3 && (
            <PaginationButtons>
              <PrevButtonWrapper>
                {currentPage > 1 && (
                  <PrevButton onClick={this.handlePrevButton}>
                    <FontAwesomeIcon icon={faChevronLeft} /> prev
                  </PrevButton>
                )}
              </PrevButtonWrapper>
              <NextButtonWrapper>
                {displayedMembersCount < teamMembers.length && (
                  <NextButton onClick={this.handleNextButton}>
                    next <FontAwesomeIcon icon={faChevronRight} />
                  </NextButton>
                )}
              </NextButtonWrapper>
            </PaginationButtons>
          )}
        </Wrapper>
      );
    }
    return <Wrapper noMembers>no team members to show</Wrapper>;
  }
}

Team.propTypes = {
  loadTeamMembers: PropTypes.func.isRequired,
  recruiterUserId: PropTypes.string.isRequired,
  teamMembers: PropTypes.arrayOf(teamMembersType).isRequired,
  companyName: PropTypes.string.isRequired,
  companyId: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
  recruiterUserId: state.agencyProfile.profileData.user.id,
  teamMembers: state.agencyProfile.profileData.teamMembers,
});

export default connect(mapStateToProps, { loadTeamMembers })(Team);
